import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  CognitoAuthProvider,
  CognitoAuthenticator,
} from "@vault/cognito-auth";
import { storeTokens } from "./lib/tokenStorage";

import { setCredentials } from "./authSlice";
import { getCognitoConfig } from "./lib/cognitoConfig";
import { decodeClaims } from "./lib/decodeClaims";
import { lt } from "./lib/translations";
import { mtikTheme } from "./lib/mtikTheme";
import styles from "./login.module.css";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const authError = location.state?.authError;

  const handleAuthenticated = useCallback(
    (tokens) => {
      storeTokens(tokens);
      const { uid, roles } = decodeClaims(tokens.idToken);
      dispatch(setCredentials({ token: tokens.idToken, uid, roles }));
      const from = location.state?.from;
      const redirectTo = from
        ? `${from.pathname || "/"}${from.search || ""}`
        : "/";
      navigate(redirectTo, { replace: true });
    },
    [dispatch, location.state, navigate]
  );

  const logo = (
    <div className={styles.logo}>
      <img src="/logo.png" alt="MTIK" />
    </div>
  );

  return (
    <CognitoAuthProvider
      config={getCognitoConfig()}
      translations={lt}
      theme={mtikTheme}
    >
      <style>{`
        .vault-dialog-root { font-family: inherit; }
        .vault-dialog-input {
          font-size: var(--font-size-input) !important;
          border-color: var(--clr-neutral-200) !important;
        }
        .vault-dialog-input:focus {
          border-color: var(--clr-blue-500) !important;
          box-shadow: 0 0 0 3px rgba(62, 118, 189, 0.25) !important;
        }
        .vault-dialog-btn-primary {
          font-weight: 500 !important;
        }
        .vault-dialog-tab[aria-selected="true"] {
          color: var(--clr-blue-700) !important;
          border-bottom-color: var(--clr-blue-700) !important;
        }
      `}</style>
      <div className={styles.page}>
        <div className={styles.card}>
          {authError && <div className={styles.error}>{authError}</div>}
          <CognitoAuthenticator
            onAuthenticated={handleAuthenticated}
            oauthProviders={["Google"]}
            showPasswordLogin
            logo={logo}
          />
        </div>
        <footer className={styles.footer}>
          © {new Date().getFullYear()} MTIK
        </footer>
      </div>
    </CognitoAuthProvider>
  );
};

export default Login;
